import EmployeesConstants from '@/store/modules/usersManagement/employees/constants';

export default {
  [EmployeesConstants.mutationTypes.setEmployees](state, employees) {
    const localState = state;

    localState.employees = employees;
  },
  [EmployeesConstants.mutationTypes.setIsLoading](state, value) {
    const localState = state;

    localState.isLoading = value;
  },
  [EmployeesConstants.mutationTypes.setEmployeesTotal](state, value) {
    const localState = state;

    localState.employeesTotal = value;
  },

  [EmployeesConstants.mutationTypes.setPaginationInfo](state, value) {
    const localState = state;

    localState.paginationInfo = value;
  },

  [EmployeesConstants.mutationTypes.setFilterQuery](state, value) {
    const localState = state;

    localState.filterQuery = value;
  },

  [EmployeesConstants.mutationTypes.setRoles](state, value) {
    const localState = state;

    localState.roles = value;
  },
  [EmployeesConstants.mutationTypes.setManagers](state, value) {
    const localState = state;

    localState.managers = value;
  },
  [EmployeesConstants.mutationTypes.setClients](state, value) {
    const localState = state;
    localState.clients = value;
  },
  [EmployeesConstants.mutationTypes.setPaginationInfoPageNumber](state, value) {
    const localState = state;
    localState.paginationInfo.pageNumber = value;
  },
};
